// import Account from '../components/Settings/Account/Account'

import { Account } from '../components/Settings/Account/Account'

export const AccountPage = () => {
    return <Account />
}
